var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IToolbarButtonType } from "../types";
import { ToolbarButtonStateless } from "./toolbar-button-stateless";
import { ToolbarButtonStateful } from "./toolbar-button-stateful";
/**
 * Internal component used to render stateful and stateless toolbar buttons.
 */
export var ToolbarButton = function (props) {
    switch (props.type) {
        case IToolbarButtonType.STATEFUL:
            return _jsx(ToolbarButtonStateful, __assign({}, props));
        case IToolbarButtonType.STATELESS:
            return _jsx(ToolbarButtonStateless, __assign({}, props));
        default:
            return null;
    }
};
export default ToolbarButton;
